<script>
export default {
  mounted() {
    this.notifySuccess(this.$vs, 'Conta ativada com sucesso!', 10000)
    this.$router.replace('/login')
  }
}
</script>